/**
 * Shown on Login / Signup when the visitor arrived from an invite link
 * (`next=/invites/...`). Steers them to Google sign-in, which is pre-verified,
 * so they skip the email-verification step that accept_invite requires for
 * unverified email/password accounts. Most caregivers have a Google address, so
 * this removes the friction for the common case without weakening the gate —
 * see docs/security-hardening.md "Email verification posture".
 */
export function InviteAuthHint() {
  return (
    <div className="mb-5 rounded-lg bg-accent-50 px-4 py-3 text-sm text-ink-soft">
      <span className="font-medium text-ink">You've been invited.</span> If your invite
      was sent to a Google address, <span className="font-medium text-ink">Continue with
      Google</span> is the quickest way in — it signs you in already verified, so you skip
      the extra email-verification step.
    </div>
  );
}
